export const PRODUCT_ONBOARDING_STEPS = {
  SALES_TAX_ENTITY_DETAILS: "SALES_TAX_ENTITY_DETAILS",
  SALES_TAX_ENTITY_OWNER_DETAILS: "SALES_TAX_ENTITY_OWNER_DETAILS",
  SALES_TAX_ENTITY_ACTIVITY_DETAILS: "SALES_TAX_ENTITY_ACTIVITY_DETAILS",
  ENTITY_DETAILS_STEP: "ENTITY_DETAILS_STEP",
  SUBSCRIPTION_COMPLETE: "SUBSCRIPTION_COMPLETE",
};
